import React from 'react';
import { motion } from 'framer-motion';
import { Terminal, Check, Globe, AlertCircle, Search } from 'lucide-react';
import { slideUp } from '../utils/animations';
export function SolutionSection() {
  return <section className="py-20 md:py-28 lg:py-32 bg-slate-50 overflow-hidden" data-id="element-304">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-305">
        <div className="grid lg:grid-cols-2 gap-10 md:gap-12 lg:gap-20 items-center" data-id="element-306">
          <div className="order-2 lg:order-1" data-id="element-307">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="bg-slate-900 rounded-xl shadow-2xl overflow-hidden border border-slate-800" data-id="element-308">
              {/* Terminal Header */}
              <div className="bg-slate-800 px-4 py-3 flex items-center gap-2" data-id="element-309">
                <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-310"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-311"></div>
                <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-312"></div>
                <div className="ml-4 text-xs text-slate-400 font-mono" data-id="element-313">
                  watchdog-cli — v2.4.0
                </div>
              </div>

              {/* Terminal Body */}
              <div className="p-6 font-mono text-sm h-[400px] overflow-y-auto custom-scrollbar" data-id="element-314">
                <div className="space-y-2" data-id="element-315">
                  <div className="text-green-400" data-id="element-316">
                    $ watchdog trademark-scan --reg="882910" --global
                  </div>
                  <div className="text-slate-400" data-id="element-317">
                    Initializing global IP scan...
                  </div>
                  <div className="text-slate-400" data-id="element-318">
                    Querying USPTO, WIPO, EUIPO databases...
                  </div>

                  <div className="py-2" data-id="element-319"></div>

                  <div className="flex items-center gap-2 text-slate-300" data-id="element-320">
                    <Check className="w-4 h-4 text-green-500" data-id="element-321" />
                    <span data-id="element-322">USPTO Status: Live/Registered</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-300" data-id="element-323">
                    <Check className="w-4 h-4 text-green-500" data-id="element-324" />
                    <span data-id="element-325">WIPO Status: Protected</span>
                  </div>

                  <div className="py-2" data-id="element-326"></div>

                  <div className="text-amber-400 flex items-center gap-2" data-id="element-327">
                    <AlertCircle className="w-4 h-4" data-id="element-328" />
                    <span data-id="element-329">WARNING: Infringement Detected</span>
                  </div>
                  <div className="pl-6 text-slate-400" data-id="element-330">
                    Type: Counterfeit Listing
                    <br data-id="element-331" />
                    Platform: Alibaba
                    <br data-id="element-332" />
                    Similarity: 99.8% match
                  </div>

                  <div className="py-2" data-id="element-333"></div>

                  <div className="text-green-400" data-id="element-334">
                    $ watchdog takedown-request --auto
                  </div>
                  <div className="text-slate-400" data-id="element-335">
                    Compiling evidence package...
                  </div>
                  <div className="text-slate-400" data-id="element-336">
                    Generating DMCA notice...
                  </div>
                  <div className="text-green-400" data-id="element-337">
                    SUCCESS: Legal notice sent to platform trust & safety.
                  </div>

                  <motion.div animate={{
                  opacity: [0, 1, 0]
                }} transition={{
                  duration: 1,
                  repeat: Infinity
                }} className="w-2 h-4 bg-slate-400 inline-block align-middle ml-1" data-id="element-338" />
                </div>
              </div>
            </motion.div>
          </div>

          <div className="order-1 lg:order-2" data-id="element-339">
            <motion.h2 initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={slideUp} className="text-3xl md:text-5xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-340">
              Legal-grade power <br data-id="element-341" />
              <span className="text-indigo-600" data-id="element-342">Human-friendly UI</span>
            </motion.h2>
            <motion.p initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={slideUp} className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-343">
              Under the hood, Watchdog runs sophisticated trademark search
              algorithms used by top IP firms. We've packaged it into a simple
              dashboard for legal teams and brand managers.
            </motion.p>

            <motion.div variants={slideUp} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="space-y-4" data-id="element-344">
              {['USPTO/WIPO Integration', 'Audit-Ready Reports', 'Team Permissions for Legal Counsel'].map(item => <div key={item} className="flex items-center gap-3" data-id="element-345">
                  <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center" data-id="element-346">
                    <Check className="w-3 h-3 text-indigo-600" data-id="element-347" />
                  </div>
                  <span className="font-medium text-slate-700" data-id="element-348">{item}</span>
                </div>)}
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}